import React from "react";
import Main from "../../components/layout/Main";
import { Col, Row } from "antd";

const AboutLeaderboard = () => {
  return (
    <Main>
      <div className="section-main">
        <div className="leaderboard-container">
          <div className="about-leaderbord-headding">
            <div className="orange-header">Accounts Leaderboard</div>
            <p>
              There are 10 account ranks which are colored and named based on
              the account level. The following shape will explain the ranks
              level.
            </p>
          </div>

          {/* Rank Rows */}
          <div className="rank-row">
            <div className="rank beginner">Beginner</div>
            <div className="rank intermediate">Intermediate</div>
            <div className="rank advance">Advance</div>
            <div className="rank expert">Expert</div>
          </div>
          <div className="rank-row">
            <div className="rank master">Master</div>
            <div className="rank platinum">Platinum</div>
            <div className="rank iconic">Iconic</div>
            <div className="rank elite">Elite</div>
          </div>
          <div className="rank-row">
            <div className="rank legendary">Legendary</div>
            <div className="rank global">Global</div>
          </div>

          <p className="desc">
            These are the ranks of the Accounts Leader Board. We will go through
            them one by one, but there is one more Account Rank will only be
            given for the players who are sponsored by the application to
            represent the application in the global competitions.
          </p>

          <div className="final-round">
            Final <span>Round</span>
          </div>

          <p>
            The above Account nickname will be added to the people chosen by the
            application admins to represent in external championships.
          </p>

          <p>
            According to the account, there will be a trophy appearing on the
            left of the user nickname that should be filled to be eligible for
            the next rank. Filling the trophy doesn’t mean you rank up
            immediately — tasks need to be completed with them too. Below are
            the tasks and trophy filling percentage for each rank.
          </p>

          <Row gutter={[12, 12]}>
            <Col span={24} sm={12} md={8} lg={8}>
              {/* Beginner */}
              <div className="task-box">
                <h3 className="beginner-title">Beginner</h3>
                <ul>
                  <li>Attending 4 Tournaments</li>
                </ul>
                <h4>Trophy Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 25%</li>
                  <li>Bronze Trophy = 25% Extra</li>
                  <li>Silver Trophy = 50% Extra</li>
                  <li>Gold Trophy = 75% Extra</li>
                </ul>
              </div>
            </Col>
            <Col span={24} sm={12} md={8} lg={8}>
              {/* Intermediate */}
              <div className="task-box">
                <h3 className="intermediate-title">Intermediate</h3>
                <ul>
                  <li>Attending 8 Tournaments</li>
                  <li>One Trophy</li>
                </ul>
                <h4>Trophy Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 10%</li>
                  <li>1 Tournament with winnings = 15%</li>
                  <li>Bronze Trophy = 20% Extra</li>
                  <li>Silver Trophy = 35% Extra</li>
                  <li>Gold Trophy = 50% Extra</li>
                </ul>
              </div>
            </Col>
            <Col span={24} sm={12} md={8} lg={8}>
              {/* Advance */}
              <div className="task-box">
                <h3 className="advance-title">Advance</h3>
                <ul>
                  <li>Attending 15 Tournaments</li>
                  <li>
                    Three Bronze Trophies / Two Silver Trophies / 1 Gold Trophy
                  </li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 7%</li>
                  <li>1 Tournament with winnings = 10%</li>
                  <li>Bronze Trophy = 15% Extra</li>
                  <li>Silver Trophy = 25% Extra</li>
                  <li>Gold Trophy = 35% Extra</li>
                </ul>
              </div>
            </Col>

            <Col span={24} sm={12} md={8} lg={8}>
              <div className="task-box">
                <h3 className="advance-title expert-title">Expert</h3>
                <ul>
                  <li>Attending 20 Tournaments</li>
                  <li>
                    12 Bronze Trophies / 6 Silver Trophies / 3 Gold Trophies
                    (for equalization)
                  </li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 5%</li>
                  <li>1 Tournament with winning = 10%</li>
                  <li>Bronze Trophy = 15% Extra</li>
                  <li>Silver Trophy = 20% Extra</li>
                  <li>Gold Trophy = 25% Extra</li>
                </ul>
              </div>
            </Col>

            <Col span={24} sm={12} md={8} lg={8}>
              {/* Master */}
              <div className="task-box">
                <h3 className="advance-title master-title">Master</h3>
                <ul>
                  <li>Attending 30 Tournaments</li>
                  <li>5 Gold Trophies</li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 5%</li>
                  <li>1 Tournament with winning = 10%</li>
                  <li>Bronze Trophy = 10% Extra</li>
                  <li>Silver Trophy = 15% Extra</li>
                  <li>Gold Trophy = 20% Extra</li>
                </ul>
              </div>
            </Col>

            <Col span={24} sm={12} md={8} lg={8}>
              {/* Platinum */}
              <div className="task-box">
                <h3 className="advance-title platinum-title">Platinum</h3>
                <ul>
                  <li>Attending 50 Tournaments</li>
                  <li>8 Gold Trophies (More than two games is must)</li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 5%</li>
                  <li>1 Tournament with winning = 10%</li>
                  <li>Bronze Trophy = 10% Extra</li>
                  <li>Silver Trophy = 15% Extra</li>
                  <li>Gold Trophy = 20% Extra</li>
                </ul>
              </div>
            </Col>

            <Col span={24} sm={12} md={8} lg={8}>
              {/* Iconic */}
              <div className="task-box">
                <h3 className="advance-title iconic-title">Iconic</h3>
                <ul>
                  <li>Attending 60 Tournaments</li>
                  <li>10 Gold Trophies (more than one games is must)</li>
                  <li>Full Ranked in one game minimum</li>
                  <li>More than one thousand followers</li>
                  <li>Win 3 Special Challenges</li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 4%</li>
                  <li>1 Tournament with winning = 8%</li>
                  <li>Bronze Trophy = 7% Extra</li>
                  <li>Silver Trophy = 12% Extra</li>
                  <li>Gold Trophy = 18% Extra</li>
                </ul>
              </div>
            </Col>

            <Col span={24} sm={12} md={8} lg={8}>
              {/* Elite */}
              <div className="task-box">
                <h3 className="advance-title elite-title">Elite</h3>
                <ul>
                  <li>Attending 70 Tournaments</li>
                  <li>
                    12 Gold Trophies for three games (4 Gold Trophies for each
                    game)
                  </li>
                  <li>Full Ranked in Three games minimum</li>
                  <li>More than Three thousand followers</li>
                  <li>Create Three tutorial videos</li>
                  <li>Stream Live for 72 Hours</li>
                  <li>Win 5 Special Challenges</li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 3%</li>
                  <li>1 Tournament with winning = 6%</li>
                  <li>Bronze Trophy = 6% Extra</li>
                  <li>Silver Trophy = 10% Extra</li>
                  <li>Gold Trophy = 14% Extra</li>
                </ul>
              </div>
            </Col>

            <Col span={24} sm={12} md={8} lg={8}>
              {/* Legendary */}
              <div className="task-box">
                <h3 className="advance-title legendary-title">Legendary</h3>
                <ul>
                  <li>Attending 80 Tournaments</li>
                  <li>
                    25 Gold Trophies for five games (5 Gold Trophies for each
                    game)
                  </li>
                  <li>Full Ranked in Five games minimum</li>
                  <li>More than Five thousand followers</li>
                  <li>Create Five tutorial videos</li>
                  <li>Stream Live for 200 Hours</li>
                  <li>Win 8 Special Challenges</li>
                </ul>
                <h4>Trophies Filling Percentage</h4>
                <ul>
                  <li>1 Tournament = 2%</li>
                  <li>1 Tournament with winning = 5%</li>
                  <li>Bronze Trophy = 5% Extra</li>
                  <li>Silver Trophy = 7% Extra</li>
                  <li>Gold Trophy = 10% Extra</li>
                </ul>
              </div>
            </Col>
            <Col span={24}>
              <div className="task-box">
                <h3 className="advance-title global-title">Global</h3>
                <p>
                  Once you reach Global, you will receive monthly tasks and gain
                  financial income in return.
                </p>
              </div>
              <div className="task-box">
                <h3 className="advance-title fialround-title">
                  Final <span>Round</span>
                </h3>
                <p>
                  This Rank will only appear if the user has been recruited by
                  the application to be part of the application family and
                  represent the application in the international competitions.
                  Once this rank appears under the user nickname, his rank will
                  be replaced and only appears inside his profile below Final
                  Round rank name.
                </p>
              </div>
            </Col>
            <Col span={24}>
              <div className="main-container">
                {/* Terms & Conditions */}
                <section className="terms-box">
                  <h2>Terms & Conditions:</h2>

                  <ol>
                    <li>
                      If the user reported and cheated in the Tournament,
                      actions:
                      <ul>
                        <li>
                          First Cheating — Disqualified & banned for 1 month + 1
                          down grade.
                        </li>
                        <li>
                          Second Cheating — Disqualified & banned for 6 months +
                          2 down grades.
                        </li>
                        <li>
                          Third Cheating — Disqualified & banned for 1 year + 3
                          down grades.
                        </li>
                      </ul>
                    </li>

                    <li>
                      If the user is disqualified for not attending after
                      registration:
                      <ul>
                        <li>
                          First time — Lose 50% trophies filling & banned for 2
                          weeks.
                        </li>
                        <li>
                          Second time — Lose whole trophy filling & banned for 1
                          month.
                        </li>
                        <li>
                          Third time — 1 down grade & banned for 3 months.
                        </li>
                      </ul>
                    </li>

                    <li>
                      If the user uses abusive language:
                      <ul>
                        <li>
                          First time — Disqualified + Lose 20% trophy filling +
                          banned 1 week.
                        </li>
                        <li>
                          Second time — Disqualified + Lose whole trophy filling
                          + banned 1 month.
                        </li>
                        <li>
                          Third time — Disqualified + 1 down grade + banned 3
                          months.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </section>

                {/* Leaderboard Section */}
                <section className="leaderboard-section">
                  <h2>Games Leader Board</h2>
                  <p>There will be nine ranks in each game:</p>

                  <div className="rank-grid">
                    {[
                      "Beginner",
                      "Experienced",
                      "Valued",
                      "Highly Valued",
                      "Top Performance",
                      "Professional",
                      "Exceptional",
                      "Epic",
                      "Immortal",
                    ].map((rank, i) => (
                      <div className="rank-box" key={i}>
                        <span>{rank}</span>
                      </div>
                    ))}
                  </div>
                </section>

                {/* Rank Description */}
                <section className="details-section">
                  <h3>
                    The above ranks will be passed as the following tasks:
                  </h3>

                  <ul>
                    <li>
                      <strong>Beginner:</strong> User has to attend 3
                      tournaments.
                    </li>

                    <li>
                      <strong>Experienced:</strong> User has to attend 5
                      tournaments + Win 1 trophy.
                    </li>

                    <li>
                      <strong>Valued:</strong> Attend 8 tournaments + Win 3
                      trophies.
                    </li>

                    <li>
                      <strong>Highly Valued:</strong> Attend 10 tournaments +
                      Win bronze/silver/gold trophies.
                    </li>

                    <li>
                      <strong>Top Performance:</strong> Attend 12 tournaments +
                      Win 8 bronze / 4 silver / 2 gold.
                    </li>

                    <li>
                      <strong>Professional:</strong> Attend 15 tournaments + Win
                      12 bronze / 6 silver / 3 gold + 1 special challenge.
                    </li>

                    <li>
                      <strong>Exceptional:</strong> Attend 18 tournaments + 4
                      gold trophies + create 1 video + 2 special challenges.
                    </li>

                    <li>
                      <strong>Epic:</strong> Attend 20 tournaments + 5 gold
                      trophies + 3 other trophies + 2 tutorial videos + 3
                      special challenges.
                    </li>

                    <li>
                      <strong>Immortal:</strong> Special tasks will be given &
                      rank from Iconic and higher.
                    </li>
                  </ul>
                </section>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Main>
  );
};

export default AboutLeaderboard;
